import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import { Col, Row} from 'react-bootstrap'

gsap.registerPlugin(ScrollTrigger);

type LandingHeroProps = {
  issue_num: string;
  issue_cover: string;
};

const LandingHero: React.FC<LandingHeroProps> = ({ issue_num, issue_cover}) => {
  const containerRef = useRef<HTMLParagraphElement | null>(null);

  useGSAP(() => {
    const section = containerRef.current;
        if(section){
            const cover_image = section.querySelector(".landing-hero-middle-image");
            const left_col = section.querySelector(".landing-hero-left");
            const right_col = section.querySelector(".landing-hero-right");

            
            //freeze the text tile wraper and trigger text reveal
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'center center',
                    end: '+=190%',
                    scrub: true,
                    markers: false,
                    pin: true,
                    anticipatePin: 1,
                },
            })
            tl.to(cover_image, {
                scale: 1.95,
            }, 0).to(left_col, {x:-100, ease: "expo.inOut"},0).to(right_col, {x:100, ease: "expo.inOut"},0)

        }

    }, []);

  return (
        <Row className="landing-hero" ref={containerRef}>
            <Col className="landing-hero-left" sm={12} md={4}>
                <h1>Issue</h1>
                <h1>&#8470; {issue_num}</h1>
            </Col>
            <Col className="landing-hero-middle" sm={12}md={4}>
                <img className='landing-hero-middle-image' src={issue_cover} />
            </Col>
            <Col className="landing-hero-right" sm={12} md={4}>
            <Link to={'/'}><img id="logo" src={require('../../assets/Fatteh-Logo.webp')} alt='fatte logo' /></Link>
            </Col>
        </Row>
  );
};

export default LandingHero;
